// api/home.js
import request from '@/utils/requests'
// 获取子模块
export function getBeforeList (params) {
  return request({
    url: '/user/child/beforeList',
    method: 'get',
    params
  })
}
// 获取子模块
export function getAfterList (params) {
  return request({
    url: '/user/child/afterList',
    method: 'get',
    params
  })
}
// 获取轮播图
export function getBanner (params) {
  return request({
    url: '/user/banner/list',
    method: 'get',
    params
  })
}
// 获取通知公告数据
export function getNotices (params) {
  return request({
    url: '/user/home/getNoticeList',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/homeIndex.js